'use strict';

module.exports = function () {
    $(document).ready(function() {
        var loc = window.location.search;
        var DEFAULT_ID = 'online';      // This needs to be implemented in Future to get this default value from custom Preferences if Business required different defaults per site...
        if ($('.store-options').length) {
            if (loc === '') {
                var defaultIdExists = $('.store-options[data-value="' + DEFAULT_ID + '"]').length;
                if (defaultIdExists) {
                    window.history.replaceState(null, '', '?id=' + DEFAULT_ID);
                    $('.store-options[data-value="' + DEFAULT_ID + '"]').trigger('click');
                } else {
                    // Set first category active if no url params found
                    var firstCategoryId = $('.store-options').first().attr('data-value');
                    window.history.replaceState(null, '', '?id=' + firstCategoryId);
                    //$('.store-options').first().addClass('js-active');
                    $('.store-options[data-value="' + firstCategoryId + '"]').trigger('click');
                }
            } else {
                // Set selected category from url param
                $('.store-options[data-value="' + loc.split('?id=')[1] + '"]').trigger('click');
            }
        }
    });

    $('.store-options').on('click', function (e) {
        e.preventDefault();

        var url = $('.where-to-buy.js-data').data('url');
        var category = $(this).attr('data-value');
        $.spinner().start();
        $('.store-option-list').removeClass('active');
        $('.store-option-list .js-active').removeClass('js-active');
        $(this).addClass('js-active');
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'html',
            data: { category: category },
            success: function (data) {
                $('.where-to-buy-stores').empty();
                $('.where-to-buy-stores').html(data);
                $.spinner().stop();

                // Show selected category in url
                window.history.replaceState(null, '', '?id=' + category);
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $('body').on('click', '.store-options-mobile-toggle', function(e) {
        $('.store-option-list').toggleClass('active');
    });

    $('body').on('click', '.subcategory-item', function (e) {
        e.preventDefault();

        var url = $('.where-to-buy.js-data').data('url');
        var category = $(this).data('catid');
        $.spinner().start();

        $('.where-to-buy-stores .js-active').removeClass('js-active');
        $(this).addClass('js-active');

        $.ajax({
            url: url,
            type: 'post',
            dataType: 'html',
            data: { category: category },
            success: function (data) {
                $('.where-to-buy-stores .store-item-list').empty();
                $('.where-to-buy-stores .store-item-list').html(data);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
};
